export const ANATOLY_PRODUCTION_ID = 2;
